export enum RecommendationType {
    Habit = 'Habits',
    Journey = 'Journeys',
    Program = 'Programs',
    Interest = 'Interests',
    StepChallenge = 'StepChallenges',
    HabitChallenge = 'HabitChallenges',
    BenefitProgram = 'BenefitPrograms'
}
